// extracted by mini-css-extract-plugin
export var formContainer = "_eu-0";
export var message = "_eu-1";